import type { UUID } from './domain';

/**
 * Global search, mirroring `SearchResponse` and `SearchHit` on the server.
 *
 * The backend names the record; the frontend decides which screen opens it,
 * from `type` and `id`.
 */

/** The server answers 422 below this; never send a shorter query. */
export const SEARCH_MIN_QUERY_LENGTH = 2;

/** Types the backend is known to emit. Anything else renders without a link. */
export type KnownSearchType =
  | 'students'
  | 'guardians'
  | 'employees'
  | 'invoices'
  | 'books'
  | 'vehicles'
  | 'routes'
  | 'assets'
  | 'admissions';

export interface SearchHit {
  type: string;
  id: UUID;
  title: string;
  /** A second line that disambiguates (number, class, status). */
  subtitle: string | null;
}

export interface SearchGroup {
  type: string;
  label: string;
  hits: SearchHit[];
  /**
   * True when this type could not be searched just now — an empty `hits` is
   * then NOT proof of no match. Render "Couldn't search {label} just now".
   */
  unavailable: boolean;
}

export interface SearchResponse {
  query: string;
  /** Only types the caller may see; up to five hits each. */
  groups: SearchGroup[];
}
